import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import styles from './detail-header.scss';
import CSSModules from 'react-css-modules';
import ListEntryImage from '../ListEntryImage';
import { isMobile } from '../../../common';
import { getImageSize } from '../StandardImage';

export const headingHeight = {
    mobile: 72,
    tablet: 112,
};

class DetailHeader extends Component {

    static propTypes = {
        detail: PropTypes.object.isRequired,
        simple: PropTypes.bool,
        isList: PropTypes.bool,
        isNavigationActive: PropTypes.bool,
        hasStandardImage: PropTypes.bool,
    };

    static defaultProps = {
        simple: false,
        isList: false,
    };

    constructor(props) {
        super(props);
        this.didScroll = false;
        this.scrollInterval;
        this.state = {
            showFixedHeader: false,
        }
    }

    componentDidMount() {
        this.setContainer();
        this.addScrollListener();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        this.removeScrollListener();
        window.removeEventListener('resize', this.handleResize);
        clearInterval(this.scrollInterval);
    }

    // on tablet up: the window scrolls - therefore container = window
    // on mobile: window does not scroll. instead the #main is set to overflow: scrollY. therefore container = #main
    setContainer = () => {
        if (isMobile()) {
            this.container = document.getElementById('main');
        } else {
            this.container = window;
        }
    };

    getContainer = () => this.container;

    addScrollListener = () => {
        this.getContainer().addEventListener('scroll', _.throttle(this.handleScroll));
    };

    removeScrollListener = () => {
        this.getContainer().removeEventListener('scroll', this.handleScroll);
    };

    handleResize = () => {
        this.removeScrollListener();
        this.setContainer();
        this.addScrollListener();
    };

    getOffsetY = () => {
        const container = this.getContainer();
        return container === window ? window.pageYOffset : container.scrollTop;
    };

    getHeight = () => {
        const { isNavigationActive, hasStandardImage } = this.props;
        let height;
        if (hasStandardImage) {
            height = getImageSize(isNavigationActive);
        } else {
            if (isMobile()) {
                height = headingHeight.mobile;
            } else {
                height = headingHeight.tablet;
            }
        }

        return parseInt(height);
    };

    handleScroll = () => {
        const self = this;
        self.didScroll = true;

        this.scrollInterval = setInterval(function() {
            if (self && self.didScroll) {
                self.didScroll = false;
                const offsetY = self.getOffsetY();
                const height = self.getHeight();
                const showFixedHeader = offsetY > height;
                if (self && self.state && self.state.showFixedHeader !== showFixedHeader) {
                    self.setState({
                        showFixedHeader: showFixedHeader
                    });
                }
            }
        }, 500);
    };

    handleClick() {
        this.container.scrollTo(0, 0);
    }

    render() {
        const { imageUrl, title, txt, icon } = this.props.detail;
        const fixedHeaderClassName = _.get(this.state, 'showFixedHeader', false) ? 'is-visible' : '';
        let styleName = 'text';
        if (this.props.isList) styleName = 'textonly';
        if (!!icon) styleName = 'textWithIcon';


        return (
            <div id="fixedHeader" className={ fixedHeaderClassName } onClick={ this.handleClick }>
                <div styleName="wrapper">
                    { !!imageUrl && <ListEntryImage imageUrl={imageUrl} /> }
                    <div styleName={styleName}>
                        { !!icon && <i styleName="icon">{ icon }</i> }
                        { !!title && <h3 styleName="title" className={this.props.simple ? 'h1' : ''}>{ title }</h3> }
                        { !!txt && <p styleName="subtitle">{ txt }</p> }
                    </div>
                </div>
            </div>
        )
    }
}

export default CSSModules(DetailHeader, styles);


// WEBPACK FOOTER //
// ./app/components/shared/DetailHeader/index.jsx